module.exports = __webpack_public_path__ + "static/media/institucional.ce803747.mp4";